import { FILTERS } from './evidenceFilters';

export const RYCZALT_EVIDENCE_LISTING_FILTERS = {
  path: '/evidences/ryczalt',
  filters: FILTERS,
};
